import { useQuery } from '@tanstack/react-query';
import { posApi } from '../../api';
import { PageHeader, LoadingState, ErrorState, EmptyState } from '../../components/common';
import { fmtCurrency, fmtMoney } from '../../utils/currency';

export function PosSalesPage() {
  const { data, isLoading, error } = useQuery({
    queryKey: ['pos', 'sales'],
    queryFn: () => posApi.listSales({ limit: 100 }),
  });

  if (isLoading) return <LoadingState />;
  if (error) return <ErrorState error={error} />;

  return (
    <div className="p-6">
      <PageHeader title="Sales history" subtitle="Last 100 POS sales (FR-POS-01)" />

      <div className="card overflow-x-auto">
        <table className="table">
          <thead>
            <tr>
              <th>Receipt</th>
              <th>Date</th>
              <th>Customer</th>
              <th>Cashier</th>
              <th className="text-right">Total</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {!data || data.length === 0 ? (
              <tr><td colSpan={6}><EmptyState message="No sales recorded." /></td></tr>
            ) : data.map((s: any) => (
              <tr key={s.id}>
                <td className="font-mono text-xs">{s.receipt_number}</td>
                <td>{new Date(s.sale_date).toLocaleString()}</td>
                <td>{s.customer_name ?? 'Walk-in'}</td>
                <td>{s.cashier_name}</td>
                <td className="text-right font-semibold">{fmtCurrency(parseFloat(s.grand_total))}</td>
                <td>
                  <span className={`badge ${s.status === 'completed' ? 'bg-sage-50 text-sage-700 ring-sage-200' : 'bg-red-50 text-red-700 ring-red-200'}`}>
                    {s.status}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
